import React from 'react';
import { Check } from 'lucide-react';

const StepIndicator = ({ currentStep }) => {
  const steps = [
    { number: 1, title: 'Service' },
    { number: 2, title: 'Property' },
    { number: 3, title: 'Price' },
    { number: 4, title: 'Appointment' },
    { number: 5, title: 'Contact' },
    { number: 6, title: 'Payment' }
  ];

  return (
    <div className="w-full" data-testid="step-indicator">
      <div className="flex items-center justify-between">
        {steps.map((step, index) => (
          <React.Fragment key={step.number}>
            <div className="flex flex-col items-center">
              <div
                className={`flex items-center justify-center w-10 h-10 rounded-full font-semibold transition-all ${
                  step.number < currentStep
                    ? 'bg-green-600 text-white'
                    : step.number === currentStep
                    ? 'bg-gradient-to-r from-green-600 to-cyan-500 text-white'
                    : 'bg-gray-200 text-gray-600'
                }`}
                data-testid={`step-${step.number}`}
              >
                {step.number < currentStep ? (
                  <Check className="w-5 h-5" />
                ) : (
                  step.number
                )}
              </div>
              <span className={`mt-2 text-xs sm:text-sm font-medium ${
                step.number <= currentStep ? 'text-green-600' : 'text-gray-500'
              }`}>
                {step.title}
              </span>
            </div>
            {index < steps.length - 1 && (
              <div
                className={`flex-1 h-1 mx-2 transition-all ${
                  step.number < currentStep ? 'bg-green-600' : 'bg-gray-200'
                }`}
              />
            )}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default StepIndicator;